import {environment} from "../../environments/environment.prod";

export function getLongAuthorName(names: string[]) {
  let longestName: string = '';
  for (let name in names) {
    if (names[name].length > longestName.length) {
      longestName = names[name];
    }
  }
  return longestName;
}
